import { createModel } from 'hox';
import { useState, useEffect } from 'react';
import {
	IItemDetailList,
	IMaterialDetailList,
	IMaintenanceDetail,
	ISettleDetails,
} from './bmsBillmaintenanceType';
import { maintenanceService } from './bmsBillmaintenanceService';
import { useBmsSaleRoDetailModel } from '../bmsBillSaleRo/bmsBillSaleRoModel';
import moment from 'moment';
export type IMaintenanceDescType = {
	workHours: number; //工时
	workHoursNum: number; //工时项数
	workHoursPrice: number; //工时费 折前
	workHoursDiscount: number; //工时优惠
	workHoursTotal: number; //工时总计 折后
	partPrice: number; //零件费 折前
	partPriceNum: number; //零件费项数
	partsDiscount: number; //零件优惠
	partsTotal: number; //零件总计 折后
	discountAll: number; //优惠金额
	receivableAll: number; //实收金额
	totalAll: number; //总计
};
export const useBmsMaintenanceDetailsModel = createModel(function () {
	const initDesc: IMaintenanceDescType = {
		workHours: 0, //工时
		workHoursNum: 0, //工时项数
		workHoursPrice: 0, //工时费 折前
		workHoursDiscount: 0, //工时优惠
		workHoursTotal: 0, //工时总计 折
		partPrice: 0, //零件费 折前
		partPriceNum: 0, //零件费项数
		partsDiscount: 0, //零件优惠
		partsTotal: 0, //零件总计 折后
		discountAll: 0, //优惠金额
		receivableAll: 0, //实收金额
		totalAll: 0, //总计
	};
	const { getBmsTreeNodeName } = useBmsSaleRoDetailModel();
	//查看数据
	//查看详情form
	const [detailLookForm, setDetailLookForm] = useState<IMaintenanceDetail>({});
	//查看项目详情列表
	const [detailItemLookList, setDetailItemLookList] = useState<IItemDetailList[]>([]);
	//查看维修用料详情列表
	const [detailMaterialLookList, setDetailMaterialLookList] = useState<IMaterialDetailList[]>([]);
	const [lookDesc, setLookDesc] = useState<IMaintenanceDescType>(initDesc);

	useEffect(() => {
		let newDesc: IMaintenanceDescType = { ...initDesc };
		detailItemLookList &&
			detailItemLookList.forEach((item) => {
				newDesc.workHours += Number(item.workHour);
				newDesc.workHoursPrice += Number(item.itemAmount);
				newDesc.workHoursDiscount += Number(item.itemAmount) - Number(item.receivableAmount);
				newDesc.workHoursTotal += Number(item.receivableAmount);
			});
		detailMaterialLookList &&
			detailMaterialLookList.forEach((item) => {
				newDesc.partPrice += Number(item.materialAmount);
				newDesc.partsDiscount += Number(item.materialAmount) - Number(item.receivableAmount);
				newDesc.partsTotal += Number(item.receivableAmount);
			});
		newDesc.discountAll = newDesc.workHoursDiscount + newDesc.partsDiscount;
		newDesc.receivableAll = newDesc.workHoursTotal + newDesc.partsTotal;
		newDesc.workHoursNum = detailItemLookList.length;
		newDesc.partPriceNum = detailMaterialLookList.length;
		if ('favorableAmount' in detailLookForm) {
			newDesc.discountAll = newDesc.discountAll + Number(detailLookForm.favorableAmount);
			newDesc.receivableAll = newDesc.receivableAll - Number(detailLookForm.favorableAmount);
		}
		setLookDesc(newDesc);
	}, [detailItemLookList, detailMaterialLookList, detailLookForm]);

	//获取一条编辑或查看数据
	const getDetailEditOne = async (id: string, pattern?: string) => {
		let { retData } = await maintenanceService.one(id);
		if (retData) {
			const { itemDetails, settleDetails, materialDetails, deliveryTime, enterTime, ...from } =
				retData;
			const newItemDetails = itemDetails?.map((item) => {
				return {
					...item,
					detailsId: item.id,
				};
			});
			const newMaterialDetails = materialDetails?.map((item) => {
				return {
					...item,
					detailsId: item.id,
					unitName: getBmsTreeNodeName(item.unitCode as string),
				};
			});
			const newFrom = {
				...from,
				enterTime: enterTime ? moment(enterTime) : null,
				deliveryTime: deliveryTime ? moment(deliveryTime) : null,
				status: getBmsTreeNodeName(from.status as string),
				serviceNatureCode: getBmsTreeNodeName(from.serviceNatureName as string),
				vehicleTypeName: getBmsTreeNodeName(from.vehicleTypeCode as string),
				settlementPartyName: getBmsTreeNodeName(from.settlementPartyCode as string),
				payType: getBmsTreeNodeName(from.payType as string),
				maintenanceMode: getBmsTreeNodeName(from.maintenanceMode as string),
				siteInformation: getBmsTreeNodeName(from.siteInformation as string),
				serviceLocationName: getBmsTreeNodeName(from.serviceLocationCode as string),
				invoiceTypeName: getBmsTreeNodeName(from.invoiceTypeCode as string),
			};
			setDetailLookForm(newFrom);
			setDetailItemLookList((newItemDetails as IItemDetailList[]) ?? []);
			setDetailMaterialLookList((newMaterialDetails as IMaterialDetailList[]) ?? []);
		}
	};

	//关闭页签清不同状态缓存
	const resetLookCatch = async (type?: string) => {
		setDetailLookForm({});
		setDetailItemLookList([]);
		setDetailMaterialLookList([]);
	};

	return {
		detailLookForm,
		detailItemLookList,
		detailMaterialLookList,
		lookDesc,
		setDetailLookForm,
		setDetailItemLookList,
		setDetailMaterialLookList,
		setLookDesc,
		getDetailEditOne,
		resetLookCatch,
	};
});
